<template>
  <div class="text-center">
    <v-dialog v-model="show" max-width="400">
      <v-card>
        <v-card-title>Solicitar factoraje</v-card-title>
        <v-card-text>
          <!-- <div
            class="mt-4"
            style="font-size: 1.3em; line-height: 1.2em; font-weight: 300; color: #454343"
          >
            ¿Estás seguro de que deseas solicitar factoraje?
          </div> -->
          <div>ID: {{ payment_id }}</div>
          <div>Cliente: {{ customerName }}</div>
          <div>Monto: ${{ payment_amount }}</div>

          <div v-if="message" class="red--text">{{ message }}</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="show = false"> Cancelar </v-btn>
          <v-btn
            text
            style="background: #1d1d1f; color: #fff"
            @click="handleSubmit"
            :disabled="inSubmit"
          >
            {{ inSubmit ? "Cargando..." : "Confirmar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaymentService from "../services/paymentService";

export default {
  props: ["payment", "visible"],

  data() {
    return {
      payment_id: null,
      payment_amount: null,
      customerName: null,
      message: "",
      inSubmit: false,
    };
  },

  methods: {
    async handleSubmit() {
      this.inSubmit = true;

      const response = await PaymentService.requestFactoring(this.payment_id);
      const status = response.status;
      const result = await response.json();

      this.inSubmit = false;

      if (status != 200) {
        this.message = result.msg;
        return;
      }

      this.$emit("showDialogAlert", result);
      this.$emit("refreshData");
      this.show = false;
    },

    reset() {
      this.days = null;
      this.payment_id = null;
      this.message = "";
    },
  },

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.reset();
          this.$emit("close");
        }
      },
    },
  },

  watch: {
    payment(item) {
      this.payment_id = item.id;
      this.payment_amount = item.amount;
      this.customerName = item.customer.business_name;
    },
  },
};
</script>
